import { CardDataController } from '@colonist/game-card-types';
export class TradeBankRatioState {
    setStartingBankTradeRatios(activeResourceCardTypes) {
        const defaultTradeRatio = 4;
        const activeResourceCards = CardDataController.getCardEnumsOfTypes(activeResourceCardTypes);
        for (const activeResourceCard of activeResourceCards){
            this.bankTradeRatios.push({
                resource: activeResourceCard,
                tradeRatio: defaultTradeRatio
            });
        }
    }
    getBankTradeRatioForCard(cardEnum) {
        for (const bankTradeRatio of this.bankTradeRatios){
            if (bankTradeRatio.resource == cardEnum) return bankTradeRatio.tradeRatio;
        }
        const defaultTradeRatio = 4;
        return defaultTradeRatio;
    }
    deserialize(data) {
        this.bankTradeRatios = data;
    }
    constructor(activeResourceCardTypes){
        this.bankTradeRatios = [];
        this.setStartingBankTradeRatios(activeResourceCardTypes);
    }
}
